export const DONATE_URL = 'https://code4.ro/ro/doneaza';
export const COMMIT_GLOBAL_URL = 'https://www.commitglobal.org/en';
export const CODE_4_URL = 'https://code4.ro';